import { render, staticRenderFns } from "./AboutPage.vue?vue&type=template&id=cf370b82&"
var script = {}
import style0 from "./AboutPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports